import { boAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { getUpdateParamsFunc } from 'utils/leadParams/bo';
import {
  identify,
  updateGlobalTracker,
  track,
  generateServerResponseError,
  generateMessageDisplayedSegment,
} from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  clientDetails: {
    isUpload: false,
  },
  orderStatus: {},
  finalStatus: {},
  basket: {},
  darResponse: {},
  redirectedDesktopUser: false,
  userId: '',
};

export const activation = {
  state: { ...initialState },
  reducers: {
    updateClientInformation(state, payload) {
      return {
        ...state,
        clientDetails: { ...state.clientDetails, ...payload },
      };
    },
    updateOrderStatus(state, payload) {
      return {
        ...state,
        orderStatus: { ...state.orderStatus, ...payload },
      };
    },
    updatefinalStatus(state, payload) {
      return {
        ...state,
        finalStatus: { ...state.finalStatus, ...payload },
      };
    },
    resetActivationStatus(state) {
      return {
        ...state,
        finalStatus: {},
        orderStatus: {},
      };
    },
    updateBasket(state, payload) {
      return {
        ...state,
        basket: payload,
      };
    },
    updateDarResponse(state, payload) {
      return {
        ...state,
        darResponse: payload,
      };
    },
    setDesktopUser(state) {
      return { ...state, redirectedDesktopUser: true };
    },
    clearActivation() {
      return { ...initialState };
    },
    updateUserId(state, payload) {
      return { ...state, userId: payload };
    },
  },
  effects: (dispatch) => {
    return {
      async createLead(params) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'PUT',
          url: boAPI.createLead,
          data: { ...params },
        })
          .then((response) => {
            this.updateBasket(response.data);
            this.updateClientInformation({ basketConfirmed: false });
            updateGlobalTracker({ lead_id: response?.data?.response?.id });
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(err, ACTIVATION, 'activation', boAPI.createLead, 'Create Lead API'),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Create Lead API'),
            });
            dispatch.apiStatus.setRequestFailed({ ...err });
            return Promise.resolve({ success: false });
          });
      },
      updateLead({ type, ...params }, state) {
        const updateFunc = getUpdateParamsFunc(type || '');
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'PATCH',
          url: boAPI.updateLead.replace(':id', state?.activation?.basket?.response?.id),
          data: { ...updateFunc(params) },
        })
          .then(() => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                err,
                ACTIVATION,
                'activation',
                boAPI.updateLead.replace(':id', state?.activation?.basket?.response?.id),
                'Update Lead API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Update Lead API'),
            });
            dispatch.apiStatus.setRequestFailed({ ...err });
            return Promise.resolve({ success: false });
          });
      },
      confirmLead(_, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'PUT',
          url: boAPI.confirmLead.replace(':id', state?.activation?.basket?.response?.id),
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                err,
                ACTIVATION,
                'activation',
                boAPI.confirmLead.replace(':id', state?.activation?.basket?.response?.id),
                'Submit Lead API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Submit Lead API'),
            });
            dispatch.apiStatus.setRequestFailed({ ...err });
            return Promise.resolve({ success: false });
          });
      },
      getLeadById({ leadID, enc = false }, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.getLeadById,
          data: {
            leadId: leadID,
            enc,
          },
        })
          .then((response) => {
            identify(response.data?.phone, {
              country: 'BO',
            });
            this.updateBasket({ response: { id: response?.data?.id, lead: response?.data } });
            const names = response.data?.lastName?.split(' ');
            this.updateClientInformation({
              cliTelephone: response.data?.phone,
              cliFirstName: response.data?.firstName,
              cliLastName: names?.[0] || '',
              dateOfBirth: response.data?.birthDate,
              identificationId: response.data?.document?.[0]?.id,
              email: response.data?.email,
              cliMotherName: names?.[1] || '',
            });
            const location = response.data?.locations?.[0];
            const comments = location.comments?.split('|');
            dispatch.inputAddress.updateLocation({
              townName: location?.city,
              streetName: location?.address,
              reference: location?.reference,
              aptno: comments.length > 1 ? comments[1] : comments[0],
              ...(comments.length > 1 && { buildingId: { name: comments[0] } }),
            });
            updateGlobalTracker({
              lead_id: leadID,
              msisdn: response.data?.phone,
              national_id_type: response.data?.document?.[0]?.type,
              national_id: response.data?.document?.[0]?.id,
              user_name: `${response.data?.firstName} ${response.data?.lastName}`,
              email: response.data?.email,
              state: location?.state,
              city: location?.city,
              town: location?.town,
              address: location?.address,
              products: response?.data?.productOfferingsList?.map((product) => {
                return {
                  product_id: product.productOfferingUUID,
                  category: 'combo',
                  name: '',
                  variant: '',
                  price: '',
                  quantity: product.quantity,
                };
              }),
            });
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, lead: response.data });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(err, ACTIVATION, 'activation', boAPI.getLeadById, 'Get Lead by ID'),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Get Lead by ID'),
            });
            dispatch.apiStatus.setRequestFailed({ ...err });
            return Promise.resolve({ success: false });
          });
      },
      async updateDAR(params) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.updateDAR,
          data: params,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            this.updateDarResponse(response?.data);
            this.updateUserId(response?.data?.body?.uuid);
            return Promise.resolve({ success: true, uuid: response?.data?.body?.uuid });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(err, ACTIVATION, 'activation', boAPI.updateDAR, 'Update DAR API'),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Update DAR API'),
            });
            return Promise.resolve({ success: false });
          });
      },
      async getDARuuid({ type = 'email' }, state) {
        dispatch.apiStatus.setProcessing(true);
        let params = {};
        if (type === 'email') {
          params['email'] = state?.activation?.clientDetails?.email;
        } else if (type === 'document') {
          params['documentType'] = 'ci';
          params['documentNumber'] = state?.activation?.clientDetails?.identificationId;
        }
        return fetchApi({
          method: 'GET',
          url: boAPI.getDARuuid,
          params,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            const uuid = response?.data?.body?.[0]?.digitalIdentity?.uuid;
            const errorCode = response?.data?.status?.[0]?.code;
            if (uuid) {
              this.updateDarResponse({ body: { uuid } });
              this.updateUserId(uuid);
              return Promise.resolve({ success: true, uuid });
            }
            if (type === 'document') {
              if (errorCode == '404') dispatch.apiStatus.setRequestFailed({ errorCode: 400, message: 'No user found' });
              else dispatch.apiStatus.setRequestFailed({ errorCode: 500, message: 'Error de servidor interno' });
            }
            return Promise.resolve({ success: false });
          })
          .catch((err) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(err, ACTIVATION, 'activation', boAPI.getDARuuid, 'Get UUID from DAR API'),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(err, ACTIVATION, 'Get UUID from DAR API'),
            });
            if (type === 'document') {
              if (err?.errorCode == 404) dispatch.apiStatus.setRequestFailed({ ...err, message: 'No user found' });
              else dispatch.apiStatus.setRequestFailed({ ...err });
            }
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
